var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "card-details-container" }, [
    _c(
      "div",
      { staticClass: "card-icon" },
      [
        _c("font-awesome-icon", {
          style: { color: _vm.cardColor },
          attrs: { icon: _vm.cardIcon, size: "6x" },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "card-details" }, [
      _c("div", { staticClass: "cardholder" }, [
        _vm._v("\n      " + _vm._s(_vm.cardholder) + "\n    "),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "card-number" },
        [
          _vm._l(_vm.cardNumber.length, function (n) {
            return [
              _vm.cardNumber[n - 1] === "x"
                ? _c("div", { key: n, staticClass: "hidden-digit" }, [
                    _c("div", { staticClass: "inner-digit" }),
                  ])
                : _c("div", { key: n, staticClass: "visible-digit" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.cardNumber[n - 1]) +
                        "\n        "
                    ),
                  ]),
              _vm._v(" "),
              n > 1 && n % 4 === 0
                ? _c("div", { key: "spacer-" + n, staticClass: "spacer" })
                : _vm._e(),
            ]
          }),
        ],
        2
      ),
      _vm._v(" "),
      _vm.cardExpiry
        ? _c("div", { staticClass: "card-expiry" }, [
            _vm._v("\n      Expires " + _vm._s(_vm.cardExpiry) + "\n    "),
          ])
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "clear-button" },
      [
        _c(
          "b-btn",
          {
            attrs: { variant: "outline-danger" },
            on: { click: _vm.clearCardDetails },
          },
          [_vm._v("\n      Clear\n    ")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }